import { createSlice, isAnyOf, PayloadAction } from '@reduxjs/toolkit'
import type { MetadataState } from './types'
import { crsApi } from '../../api/crs/react'

const initialState: MetadataState = {
  user: { crs: undefined },
  auth: { token: { crs: undefined } },
  rememberMeEmail: undefined,
  targetGroup: undefined,
  domain: undefined,
}
export const name = 'metadata'

export const metadataSlice = createSlice({
  name,
  initialState,
  reducers: {
    updateRememberMeEmail: (state: MetadataState, { payload }: PayloadAction<string | undefined>) => {
      state.rememberMeEmail = payload
    },
    updateSelectedGroupId: (state: MetadataState, { payload }: PayloadAction<string | undefined>) => {
      state.targetGroup = payload
    },
    updateCrsToken: (state: MetadataState, { payload }: PayloadAction<string | undefined>) => {
      state.auth.token.crs = payload
    },
    updateDomain: (state: MetadataState, { payload }: PayloadAction<string>) => {
      state.domain = payload
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(
        crsApi.endpoints.userLogin.matchFulfilled,
        crsApi.endpoints.verifyMfaCode.matchFulfilled,
        crsApi.endpoints.verifyBackupCode.matchFulfilled,
        crsApi.endpoints.manageProfile.matchFulfilled,
        crsApi.endpoints.resetPassword.matchFulfilled,
        crsApi.endpoints.accountsProfile.matchFulfilled,
      ),
      (state, { payload: { results } }) => {
        if (results) {
          const { token, ...userData } = results
          state.user.crs = userData
          state.auth.token.crs = token
        }
      },
    )
    builder.addMatcher(
      isAnyOf(
        crsApi.endpoints.userLogout.matchRejected,
        crsApi.endpoints.userLogout.matchFulfilled,
        crsApi.endpoints.verifyToken.matchRejected,
      ),
      (state) => {
        state.user.crs = undefined
        state.auth.token.crs = undefined
        state.targetGroup = undefined
      },
    )
    builder.addMatcher(crsApi.endpoints.verifyDisableMfa.matchFulfilled, (state) => {
      if (state.user.crs) {
        state.user.crs.member.two_factor_auth = 0
      }
    })
  },
})

export const { updateRememberMeEmail, updateSelectedGroupId, updateCrsToken, updateDomain } = metadataSlice.actions

export default metadataSlice.reducer
